import type { FC } from 'react'
import { useTheme } from '@emotion/react'

import Image from '@segment/matcha/components/Image'
import Elevation from '@segment/matcha/components/Elevation'

import HeroPng2x from './assets/Hero@2x.png'
import HeroWebp from './assets/Hero.webp'
import HeroWebp2x from './assets/Hero@2x.webp'

import HeroMobilePng from './assets/HeroMobile.png'
import HeroMobilePng2x from './assets/HeroMobile@2x.png'
import HeroMobileWebp from './assets/HeroMobile.webp'
import HeroMobileWebp2x from './assets/HeroMobile@2x.webp'

interface HeroImageProps {
  alt: string
}
const HeroImage: FC<HeroImageProps> = ({ alt }) => {
  const { breakpoints } = useTheme()
  return (
    <Elevation elevation={4} type="dropShadow">
      <picture>
        <source
          type="image/webp"
          media={breakpoints.down(`md`, false)}
          srcSet={`${HeroMobileWebp}, ${HeroMobileWebp2x} 2x`}
        />
        <source
          type="image/png"
          media={breakpoints.down(`md`, false)}
          srcSet={`${HeroMobilePng} ${HeroMobilePng2x} 2x`}
        />
        <source type="image/webp" media={breakpoints.up(`md`, false)} srcSet={`${HeroWebp}, ${HeroWebp2x} 2x`} />

        <Image width="640" height="441" src={HeroPng2x} alt={alt} />
      </picture>
    </Elevation>
  )
}

export default HeroImage
